import { createI18n } from 'vue-i18n'
import { messages } from '@/locales'

// Use VUE_APP_LOCALE from .env to set the display language (default: 'en')
export const locale = process.env.VUE_APP_LOCALE || 'en'

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  messages,
  globalInjection: true,
})
